// extracted by mini-css-extract-plugin
export default {"DashboardContentHeading":"DashboardContentHeading_DashboardContentHeading__lF496"};